import React from "react";

const AuthContext = React.createContext(localStorage.getItem("token"));

export { AuthContext };
